import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Routers from './Route';
import Providers from './Providers';
import { ToastContainer, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Toaster } from 'sonner';
import Fallback from './Fallback';
import { SpeedInsights } from '@vercel/speed-insights/react';

const App = () => {
  return (
    <div className='App'>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <Providers>
          <ErrorBoundary
            FallbackComponent={Fallback}
            onReset={() => {
              // Reset the state of your app so the error doesn't happen again
            }}
          >
            <Routers />
          </ErrorBoundary>
          <Toaster richColors />
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Flip}
          />
        </Providers>
      </GoogleOAuthProvider>
      <SpeedInsights />
    </div>
  );
};

export default App;